import React from "react";
import LocationFilter from "./LocationFilter";
import CategoriesFilter from "./CategoriesFilter";
import PriceFilter from "./PriceFilter";
import Search from "./Search";

const AdsFilter = ({ onFilterChange, defaultFilters }) => {
  return (
    <>
      <Search
        onFilterChange={onFilterChange}
        defaultQuery={defaultFilters.query}
      />
      <LocationFilter
        onFilterChange={onFilterChange}
        defaultLocation={defaultFilters.location}
      />

      <PriceFilter
        onFilterChange={onFilterChange}
        defaultFilters={defaultFilters}
      />

      <CategoriesFilter />
    </>
  );
};

export default AdsFilter;
